export function getBackendApiUrlMap() {
  return process.env.BACKEND_API_URL_MAP // nosemgrep
    ? JSON.parse(process.env.BACKEND_API_URL_MAP) // nosemgrep
    : {};
}

export function getBackendApiUrlForCurrentInstance() {
  const currentInstance = window.location.hostname;
  return getBackendApiUrlMap()[currentInstance];
}

export type Environment = "dev" | "stage" | "prod";
